<mat-error *ngIf="!isToHide" class="inline-error">
  <strong>{{text}}</strong></mat-error>
